import { format } from 'date-fns'
import Link from 'next/link'

interface OfferingsListProps {
	heading?: string
	addArchiveLink?: boolean
	offerings: any
	link?: any
}

const OfferingsList = (props: OfferingsListProps) => {

	const { heading, addArchiveLink, offerings, link } = props

	return (

		<section className="content-container">
			{heading || link ? (
				<header className="content-container__header-wrapper">
					<div className="content-container__header-title">
						<h2>{heading}</h2>
					</div>
					<div className="content-container__header-cta">
						{addArchiveLink && <Link href={`/offerings`} className='button button--inverted'>See all offerings →</Link>}
					</div>
				</header>
			) : null}
			
			<div className="flex-table">
				<div className="flex-table__row flex-table__row--header">
					<div className="flex-table__row-inner">
						<div className="flex-table__column flex-table__column--offerings-sector">Sector</div>
						<div className="flex-table__column flex-table__column--offerings-title">Reference</div>
						<div className="flex-table__column flex-table__column--offerings-date">Date</div>
						<div className="flex-table__column flex-table__column--offerings-link"></div>
					</div>
				</div>
				{offerings.map((offering: any) => {
					const sector = offering.relatedSectors && offering.relatedSectors.length > 0 ? offering.relatedSectors[0] : null;
					const offeringTitle = offering.subheading ? offering.title + ' – ' + offering.subheading : offering.title;
					
					return (
						<Link href={`/${offering.uri}`} key={offering.id} className="flex-table__row flex-table__row--content offering-link">
							<div className="flex-table__row-inner">
								<div className="flex-table__column flex-table__column--offerings-sector">
									{sector && <Link href={`/${sector.uri}`} className='button button--inverted'>{sector.title}</Link>}
								</div>
								<div className="flex-table__column flex-table__column--offerings-title">{offeringTitle}</div>
								<div className="flex-table__column flex-table__column--offerings-date">{format(new Date(offering.postDate), 'MMMM do yyyy')}</div>
								<div className="flex-table__column flex-table__column--offerings-link">
									<Link href={`/${offering.uri}`} className='button button--standard'>Access offering</Link>
								</div>
							</div>
						</Link>
					)
				})}
			</div>
		</section>

	)

}
export default OfferingsList
